import React from 'react';
import styled from 'styled-components';
import { Spinner as CarvanaSpinner } from '@carvana/showroom-spinner';

const DefaultSpinnerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const SpinnerWrapper = styled(DefaultSpinnerWrapper)`
  min-height: 500px;
  margin-top: 5%;
  margin: auto;
`;
const OvpSpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

export const OvpSpinner = () => {
  return (
    <OvpSpinnerWrapper>
      <CarvanaSpinner />
    </OvpSpinnerWrapper>
  );
};

export const DefaultSpinner = ({ customStyles }: any) => (
  <DefaultSpinnerWrapper data-testid="loading-spinner" style={customStyles}>
    <CarvanaSpinner />
  </DefaultSpinnerWrapper>
);

export const Spinner = ({ customStyles }: any) => (
  <SpinnerWrapper style={customStyles}>
    <CarvanaSpinner />
  </SpinnerWrapper>
);

export default Spinner;
